import React from "react";
import { useMutation } from "@apollo/client";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "components/haven-design/snackbar";
import { tagEligible, tagEligibleVariables } from "types/gql-types";
import logger from "services/logger";
import { TAG_ELIGIBILITY } from "../../interests-profile/components/actions-query";

type Props = {
  currentInterestID: string;
  hasStar: boolean;
  onStar: (bool: boolean) => void;
}

const Star: React.FC<Props> = (props) => {
  const { currentInterestID, hasStar, onStar } = props;
  const { openSnackbar } = useSnackbar();
  const [setStarred, { loading }] = useMutation<tagEligible, tagEligibleVariables>(
    TAG_ELIGIBILITY,
    { refetchQueries: ["QueryInterestProfile"] },
  );
  const icon = hasStar ? "star" : "star-o";
  const color = hasStar ? "#f6ac00" : "#979797";

  return (
    <a
      data-cy="star"
      onClick={async (e) => {
        e.preventDefault();
        // flip eligibility to toggle star to other state
        const isEligible = !hasStar;
        const variables = { interestId: currentInterestID, isEligible };

        const message = isEligible ? "Starred application" : "Unstarred application";

        onStar(isEligible);

        try {
          await setStarred({ variables });
          openSnackbar({ message, status: "success" });
        } catch (error) {
          logger.sendError(error as Error);
          openSnackbar({ message: "Error updating star", status: "error" });
        }
      }}
      style={{ marginTop: -12 }}
    >
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <span className={`fa fa-${icon}`} style={{ paddingRight: 3, color }} />
      )}
    </a>
  );
};

export default Star;
